import * as React from 'react';
import { ToastContainer, ToastOptions, toast } from 'react-toastify';

import { devInfoStore } from '@app/Stores/DevInfoStore';
import { ApiUrls } from '@app/AppConstants';
import ApiService from '@app/Services/ApiService';

export class NotificationContainer extends React.Component {
    render() {
        return <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            draggable
            pauseOnHover
            theme="colored"
            closeButton
        />;
    }
}

export class NotificationHandler {
    public static showConsoleError(errorParameters: IArguments) {
        const msg = errorParameters[0];
        const url = errorParameters[1];
        const lineNo = errorParameters[2];
        const columnNo = errorParameters[3];
        const error = errorParameters[4];

        const string = (msg + '').toLowerCase();
        let message = 'script error';
        if (string.indexOf(message) > -1) {
            message = 'Script Error: See Browser Console for Detail';
        } else {
            message = [
                'Message: ' + msg,
                'URL: ' + (url || ''),
                'Line: ' + (lineNo || ''),
                'Column: ' + (columnNo || ''),
                'Error object: ' + JSON.stringify(error)
            ].join(' - ');
        }

        if (devInfoStore.isDevelopment) {
            NotificationHandler.showError(message, 'Error');
        }

        const params = {
            message: msg,
            source: url || '' + ' Line: ' + lineNo + ' Column: ' + columnNo
        };
        ApiService.postData(ApiUrls.ErrorUrl, params);
    }

    public static showError(message: React.ReactNode, title: string = 'Error') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.error(content);
    }

    public static showInfo(message: string, title: string = 'Info') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.info(content);
    }

    public static showWarning(message: string, title: string = 'Warning') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.warning(content);
    }

    public static showSuccess(message: string, title: string = 'Success', optionsOverride?: ToastOptions) {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.success(content, optionsOverride);
    }
}
